<template>
  <DialogComponent
    ref="dialog"
    type="fullscreen"
    :dialogVisible="isOpen"
    @closed="onClosed"
    noInnerPadding
    mainClass="[&_.fullscreenDialogBox]:overflow-hidden!"
    hideCloseButton
  >
    <PackageDetails :deliveryData="deliveryData" @close="close" />
  </DialogComponent>
</template>

<script setup>
import { ref, onUnmounted } from 'vue'
import PackageDetails from './PackageDetails.vue'
import { bus } from '@core/events/eventSystem'
import constants from '@core/utils/constants'

const dialog = ref(null)
const deliveryData = ref(null)
const isOpen = ref(false)

let packagePollInterval = null

function startPolling() {
  stopPolling()
  const packageId = deliveryData.value?.id || deliveryData.value?._id
  if (!packageId) return

  // Immediate fetch
  bus.emit(constants.EVENTS.PACKAGES.DETAIL, packageId)

  // Then every 5s
  packagePollInterval = setInterval(() => {
    const id = deliveryData.value?.id || deliveryData.value?._id
    if (!id) return
    bus.emit(constants.EVENTS.PACKAGES.DETAIL, id)
  }, 5000)
}

function stopPolling() {
  if (packagePollInterval) {
    clearInterval(packagePollInterval)
    packagePollInterval = null
  }
}

// When controller responds, update local deliveryData if it's the same package
bus.on(constants.EVENTS.PACKAGES.DETAIL_LOADED, (updatedPackage) => {
  if (!updatedPackage) return
  const currentId = deliveryData.value?.id || deliveryData.value?._id
  const updatedId = updatedPackage.id || updatedPackage._id
  if (currentId && updatedId && currentId === updatedId) {
    deliveryData.value = updatedPackage
  }
})

function showDetails(data) {
  deliveryData.value = data
  isOpen.value = true
  startPolling()
}

function close() {
  isOpen.value = false
  stopPolling()
}

const onClosed = () => {
  isOpen.value = false
  stopPolling()
}

onUnmounted(() => {
  stopPolling()
})

defineExpose({
  showDetails
})
</script>
